import { useSearchParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { ScanCardController } from "./scan-card-controller";
import { ScanCardPage } from "./scan-card-page";

/**
 * The flow lives in the controller; the URL says whose scan it is and which one
 * is under review, so a refresh reopens it.
 */
export function ScanCardRoute({ deps }: { deps: AppDeps }) {
  const [params, setParams] = useSearchParams();
  // `?customer=<id>`: scanning for a counter customer, from their page.
  const customerId = params.get("customer");
  const scanId = params.get("scan");
  return (
    <Subtree
      key="scan-card"
      deps={[customerId]}
      controller={() =>
        new ScanCardController(
          pick(
            deps,
            "client",
            "session",
            "authHandler",
            "storeRepository",
            "locationsRepository",
            "reviewQueueRepository",
            "customersRepository",
          ),
          {
            showScan: (id) =>
              setParams(
                (prev) => {
                  const next = new URLSearchParams(prev);
                  if (id) next.set("scan", id);
                  else next.delete("scan");
                  return next;
                },
                { replace: true },
              ),
          },
          scanId,
          undefined,
          customerId,
        )
      }
    >
      <ScanCardPage />
    </Subtree>
  );
}
